export default __webpack_public_path__ + "static/media/testify11.c76b7cd3.png";